<template>
  <svg :class="className" :width="width" :height="height" :viewBox="viewBox" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path id="Vector" d="M7 14C6.03167 14 5.12167 13.8161 4.27 13.4484C3.41833 13.0807 2.6775 12.582 2.0475 11.9525C1.4175 11.3225 0.918867 10.5817 0.5516 9.73C0.184333 8.87833 0.000466667 7.96833 0 7C0 6.03167 0.183867 5.12167 0.5516 4.27C0.919333 3.41833 1.41797 2.6775 2.0475 2.0475C2.6775 1.4175 3.41833 0.918867 4.27 0.5516C5.12167 0.184333 6.03167 0.000466667 7 0C7.96833 0 8.87833 0.183867 9.73 0.5516C10.5817 0.919333 11.3225 1.41797 11.9525 2.0475C12.5825 2.6775 13.0814 3.41833 13.4491 4.27C13.8168 5.12167 14.0005 6.03167 14 7C14 7.96833 13.8161 8.87833 13.4484 9.73C13.0807 10.5817 12.582 11.3225 11.9525 11.9525C11.3225 12.5825 10.5817 13.0814 9.73 13.4491C8.87833 13.8168 7.96833 14.0005 7 14ZM4.69 10.2375L6.8425 9.2925C6.90083 9.26917 6.95637 9.2575 7.0091 9.2575C7.06183 9.2575 7.11713 9.26917 7.175 9.2925L9.31 10.2375C9.47333 10.3075 9.61917 10.2811 9.7475 10.1584C9.87583 10.0357 9.905 9.89287 9.835 9.73L7.3675 3.71C7.2975 3.54667 7.175 3.465 7 3.465C6.825 3.465 6.7025 3.54667 6.6325 3.71L4.165 9.73C4.095 9.89333 4.12417 10.0364 4.2525 10.1591C4.38083 10.2818 4.52667 10.308 4.69 10.2375Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'HelpIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '14',
    },
    height: {
      type: String,
      default: '14',
    },
    viewBox: {
      type: String,
      default: '0 0 14 14',
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
};
</script>
